import React from 'react';
import BaseField, {
	BaseFieldProps,
} from '../../../Base/Components/Inputs/BaseField/BaseField';
import LaboratoryPrimarySampleSelection from './LaboratoryPrimarySampleSelection';

interface Props extends BaseFieldProps {
	requisitionId: string;
}

const LaboratoryPrimarySampleSelectionField: React.FC<Props> = props => {
	return (
		<BaseField {...props}>
			<LaboratoryPrimarySampleSelection requisitionId={props.requisitionId} />
		</BaseField>
	);
};

export default LaboratoryPrimarySampleSelectionField;
